export const SET_VEHICLES = "@@app/SET_VEHICLES";
export const SET_DATA_VEHICLES_STATE = "@@app/SET_DATA_VEHICLES_STATE";
export const SET_DATA_VEHICLES_KEY_STATE = "@@app/SET_DATA_VEHICLES_KEY_STATE";
export const RESET_DATA_VEHICLES = "@@app/RESET_DATA_VEHICLES";